import { Box } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
// import Footer from '../../components/LandingPageComponents/mobile/Footer';
// import Header from '../../components/LandingPageComponents/mobile/Header';
// import Hero from '../../components/LandingPageComponents/mobile/Hero';
// import Mission from '../../components/LandingPageComponents/mobile/Mission';
import Splash from '../../components/LandingPageComponents/mobile/Splash';
import Login from 'pages/Login';

const LandingPage = () => {
    const [screen, setscreen] = useState(window.screen.width);
    useEffect(() => {
        window.addEventListener('resize', () => {
            setscreen(window.screen.width);
        });
    });
    const token = window.localStorage.getItem('token');

    return token ? (
        <Navigate to="/dashboard" />
    ) : (
        <Box height="full">
            {screen <= 500 ? (
                <>
                    <Splash />
                </>
            ) : (
                <Login />
            )}
        </Box>
    );
};

export default LandingPage;
